<template>
  <component :is="tag" class="m-nav__link" v-bind="attrs">
    <slot />
  </component>
</template>

<script>
import { clickableTag } from '../../../lib/type-validators'
import { getLinkAttrs } from '../../../lib/utils'
export default {
  name: 'MNavLink',
  inheritAttrs: false,
  props: {
    /**
     * The HTML tag to render
     */
    tag: {
      type: [Object, String],
      default: 'a',
      validator: clickableTag,
    },
  },
  computed: {
    attrs() {
      return getLinkAttrs(this.$attrs, this.tag)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/breakpoint';
@use '../../../sass/framework/mixins/hover';

.m-nav__link {
  @include hover.hover-transition(background-color);
  align-items: center;
  background: none;
  border: none;
  color: var(--color-text-body-dark);
  cursor: pointer;
  display: flex;
  font-weight: var(--font-weight-bold);
  height: 100%;
  padding: 0 var(--spacing-16);
  text-decoration: none;

  @include breakpoint.breakpoint(widescreen-up) {
    padding: 0 var(--spacing-24);
  }

  @include hover.hover-styles {
    background-color: var(--skin-clickable-background-hover);
  }
}
</style>
